import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
`;

const HeaderRow = styled.tr`
  background-color: #f5f5f5;
`;

const HeaderColumn = styled.th`
  text-align: left;
  padding: 12px 8px;
`;

const RowColumn = styled.td`
  text-align: left;
  padding: 12px 8px;
`;

export default ({
  columns = [],
  data = [],
  mobileMode,
}) => {
  return (
    <Table>
      <thead>
        <HeaderRow>
        {
          columns.map((column, index) => {
            const { title, headerStyle } = column;
            const style = headerStyle || {};
            if (mobileMode) {
              style.display = 'table-row';
            }
            return (
              <HeaderColumn key={`${title}-${index}`} style={style}>
                {title}
              </HeaderColumn>
            )
          })
        }
        </HeaderRow>
      </thead>
      <tbody>
        {
          data.map((dataObj, index) => {
            return (
              <tr key={`row-${index}`}>
                {
                  columns.map(column => {
                    const { field, rowStyle, renderer } = column;
                    const value = renderer ? renderer(dataObj) : (dataObj[field] || '');
                    const style = rowStyle || {};
                    if (mobileMode) {
                      style.display = 'table-row';
                    }
                    return (
                      <RowColumn key={`row-${index}-${field}`} style={style}>
                        {value}
                      </RowColumn>
                    )
                  })
                }
              </tr>
            )
          })
        }
      </tbody>
    </Table>
  )
}